import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const OrganizationIcon = (props: IconProps) => (
  <Icon w="40px" h="40px" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" />
    <path d="M20.0001 13.3333V8H6.66675v24H33.3334V13.3333H20.0001Zm-2.6667 16H9.33341v-2.6666h7.99999v2.6666Zm0-5.3333H9.33341v-2.6667h7.99999V24Zm0-5.3333H9.33341V16h7.99999v2.6667Zm0-5.3334H9.33341v-2.6666h7.99999v2.6666Zm13.3333 16H20.0001V16h10.6666v13.3333Zm-2.6666-10.6666h-5.3334v2.6666h5.3334v-2.6666Zm0 5.3333h-5.3334v2.6667h5.3334V24Z" />
  </Icon>
);

export default memo(OrganizationIcon);
